import React, { useState, useEffect } from "react";
import {
  TextField,
  ThemeProvider,
  createTheme,
  Autocomplete,
} from "@mui/material";
import { Fragment, useMemo, useRef } from "react";

import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
// import { common_axios } from "../../..";
import { common_axios } from "../../../App";
import { Formik, useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../../components/Loader";
import Backdrop from "@mui/material/Backdrop";
import DeleteIcon from "@mui/icons-material/Delete";
import ColumnFilter from "../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import RuleIcon from "@mui/icons-material/Rule";
import Toggle from "./Toggle";
import EditIcon from "@mui/icons-material/Edit";
import { InputAdornment, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import ActivateDeactivate from "../RulesManagement/ActivateDeactivate";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { Height, Save } from "@mui/icons-material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import MainCampaign from "../SendSms/CampaignManagerTable/MainCampaign";
import { AndEdit } from "./AndEdit";
import { OrEdit } from "./OrEdit";
import { ActionEdit } from "./ActionEdit";
import { useDispatch, useSelector } from "react-redux";
import { andState, AndOrActionState } from "../../../redux/features/pageSlices";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CheckIcon from "@mui/icons-material/Check";
const RuleList = () => {
  const AndOrActionTab = useSelector(
    (state) => state.pageReducer.AndOrActionState?.payload
  );

  console.log("uu", AndOrActionTab);
  const [UpdateStatus, setUpdateStatus] = useState();
  // console.log("yhhyy", UpdateStatus);
  const [open, setOpen] = useState();
  const [updateValue, setUpdateValue] = useState();
  const customId1 = "custom-id-yess";

  const [IdEdit, setIdEdit] = useState();
  const [AttributeEdit, setAttributeEdit] = useState();
  const [Valuesdit, setValuesdit] = useState();
  const [ruleview, setRuleView] = useState();
  // console.log("ruleee",ruleview)
  const [ResponseEdit, setResponseEdit] = useState(undefined);
  const [data1, setData1] = useState(["Activate", "Deactivate"]);
  // console.log("data1------", data1);
  const [age, setAge] = React.useState("");
  const [andArray, setAndArray] = useState([]);
  const [orArray, setOrArray] = useState([]);
  console.log("andArray--", orArray);
  const [actionArray, setActionArray] = useState([]);
  const [attribute2Index, setAtribute2Index] = useState(undefined);
  const [attribute3Index, setAtribute3Index] = useState(undefined);
  const [attribute1Index, setAtribute1Index] = useState(undefined);

  const [defaultActDeact, setdefaultActDeact] = useState("");
  // const [totalPage, setTotalPage] = useState();
  // const [totalPageCount, settotalPageCount] = useState();
  // const [disabledPrevious, setDisabledPrevious] = useState(true);
  // const [disableNext, setDisableNext] = useState(true);
  // const [PageSize1, setPageSize1] = useState(10);
  // const [pageNumber1, setPageNumber1] = useState(0);
  const [disableFieldsRule, setDisableFieldsRule] = useState(true);
  console.log("dis--", disableFieldsRule);

  const [TableStatus, setTableStatus] = useState({
    // hideShow: false,
    pageNo: 0,
    pageSize: 10,
  });
  const [data2, setData2] = useState([]);
  const handleChange = (event) => {
    setAge(event.target.value);
  };
  const dispatch = useDispatch();
  const callbackfunction1 = (childData) => {
    setUpdateValue(childData);
  };
  // console.log("update54", disableFields);

  const callbackAndSelector = (child, child2) => {
    console.log("parent1", child2);
    setAndArray(child);
    setDisableFieldsRule(child2);
  };
  const callbackOrSelector = (child, child2) => {
    console.log("parent2", child);
    setOrArray(child);
    setDisableFieldsRule(child2);
  };
  const callbackActionSelector = (child, child2) => {
    console.log("parent8", child);
    setActionArray(child);
    setDisableFieldsRule(child2);
  };

  const [submitDisable, setSubmitDisable] = useState(false);
  console.log("submit--", submitDisable);

  const [submitDisable1, setSubmitDisable1] = useState(false);
  useEffect(() => {
    if (andArray.length == 0 && orArray.length == 0) {
      setSubmitDisable(true);
    } else if (andArray.length == 0 || orArray.length == 0) {
      setSubmitDisable(false);
    }

    for (let i = 0; i < andArray.length; i++) {
      if (andArray?.length == 0) {
        setSubmitDisable(false);
      } else if (
        (andArray[i]?.attribute == null ||
          andArray[i]?.operations == null ||
          (andArray[i]?.values == "" && andArray[i]?.messageSource == null)) &&
        andArray?.length > 0
      ) {
        setSubmitDisable(true);
      } else {
        setSubmitDisable(false);
      }
    }
  }, [andArray]);
  useEffect(() => {
    if (orArray.length == 0 && andArray.length == 0) {
      setSubmitDisable(true);
    }
    for (let i = 0; i < orArray.length; i++) {
      if (orArray?.length == 0) {
        setSubmitDisable(false);
      } else if (
        orArray[i]?.attribute == null ||
        orArray[i]?.operations == null ||
        (orArray[i]?.values == "" && orArray[i]?.messageSource == null)
      ) {
        setSubmitDisable(true);
      } else {
        setSubmitDisable(false);
      }
    }
  }, [orArray]);

  useEffect(() => {
    if (actionArray.length == 0) {
      setSubmitDisable1(true);
      // setSubmitDisable(true)
    }
    for (let i = 0; i < actionArray.length; i++) {
      if (actionArray?.length == 0) {
        setSubmitDisable1(false);
      } else if (
        actionArray[i]?.attribute == null ||
        actionArray[i]?.operations == null ||
        actionArray[i]?.values == ""
      ) {
        setSubmitDisable1(true);
      } else {
        setSubmitDisable1(false);
      }
    }
  }, [actionArray]);

  // ......................................GetAPI.........................................//
  async function SpamTableget() {
    // console.log("dta212", data);
    try {
      setOpen(true);
      const result = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/get/spam`,
        {
          pageSize: TableStatus.pageSize,
          pageNo: TableStatus.pageNo,
        }

        // `http://192.168.167.66:5002/v1/drools-rule/get-spam/rules?pageNo=${pageNumber1}&pageSize=${PageSize1}`
      );

      // console.log("result get api.........", result);

      if (result.data.statusDescription.statusCode == 200) {
        setOpen(false);

        setData(result.data.spamResponse);
        setData2(result.data);
        // await setTotalPage(result.data.rulesModels.pageable.pageNumber);
        // await settotalPageCount(result.data.rulesModels.pageable.pageSize);
      } else {
        setOpen(false);
        toast.error(result.data.statusDescription.statusdescription, {
          toastId: customId1,
          theme: "colored",
        });
      }
    } catch (error) {
      setOpen(false);
      toast.error("Please Check Your Network", {
        toastId: customId1,
        theme: "colored",
      });
    }
  }

  useEffect(() => {
    // SpamTableGet();
    SpamTableget();
  }, [TableStatus.pageSize, TableStatus.pageNo]);

  // -----------------------------------Filter Table-------------------------------//

  // .........................GetAPI spam table.....................................//

  // const [spamTable, setSpamTable] = useState([]);
  const [data, setData] = useState([]);
  console.log("data-55---", data);
  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  console.log("firs7t", selectedUserDetail);
  const [Status, setStatus] = useState("allUser");
  const [id, setId] = useState("");
  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const [ruleModelOpen, setRuleModelOpen] = useState(undefined);
  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);
  const modelButtonRuleOpen = useRef(null);
  const approveUserModal = async (cell) => {
    console.log(cell.row.original);
    await document.getElementById("home-tab").click();
    await setSelectedUserDetailApprove(cell.row.original);
    // setRuleModelOpen(cell.row.original);
    setIdEdit(cell?.row?.original?.id);
    setAttributeEdit(cell.row.original.attribute);
    setValuesdit(cell.row.original.values);
    setResponseEdit(cell.row.original);
    console.log("payload", cell.row.original);
    dispatch(andState(cell.row.original));
    await modelButtonApprove.current.click();
    // await modelButtonRuleOpen.current.click();
  };

  const viewUserModal = async (cell) => {
    // alert("hlo");
    setRuleModelOpen(cell.row.original);
    await modelButtonRuleOpen.current.click();
    setRuleView(cell.row.original.rule);
    // console.log("cell222",cell)
  };
  // console.log("first-",selectedUserDetailApprove.status)
  useEffect(() => {
    let x = selectedUserDetailApprove?.status;
    // console.log("x--", x);
    setAge(x);
  }, [selectedUserDetailApprove]);
  const rejectUserModal = async (cell) => {
    console.log(cell.row.original);
    await setSelectedUserDetail(cell.row.original);
    await modelButtonReject.current.click();
  };

  const rejectUserApi = async (selectedUserDetail) => {
    // console.log("selectedUserDetail-----==", selectedUserDetail);

    try {
      setOpen(true);
      const deleteResponse = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/delete/spam`,
        // "http://192.168.167.66:5002/v1/drools-rule/delete/spam",
        {
          id: selectedUserDetail.spamId,
          status: selectedUserDetail.status,
        }
      );
      // console.log("deleteResponse--------", deleteResponse);
      if (deleteResponse.data.statusDescription.statusCode == 200) {
        setOpen(false);
        SpamTableget();
        // toast.success(deleteResponse.data.statusDescription.statusdescription, {
        //   theme: "colored",
        // });
        toast.success("Rule Deleted Successfully!!", {
          theme: "colored",
          toastId: customId1,
        });
      } else {
        setOpen(false);
        toast.error(deleteResponse.data.statusDescription.statusdescription, {
          theme: "colored",
          toastId: customId1,
        });
      }
    } catch (error) {
      toast.error("Please Check Your Network");

      setOpen(false);
    }
  };

  // console.log("updatestatus-----", UpdateStatus);
  const ActiveButton = () => {
    // alert("hii");
    setUpdateStatus("1");
  };

  const DeActiveButton = () => {
    // alert("deacctive");
    setUpdateStatus("0");
  };
  const ActivateDeactivate = async (cell) => {
    // console.log("cell11", selectedUserDetailApprove);
    try {
      const res = await common_axios.post(
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/update-status/rules`,
        // `http://192.168.167.66:5002/v1/drools-rule/update-status/rules`,

        {
          // status: updateValue,
          status: cell?.row?.original?.status == 1 ? "0" : "1",
          id: cell?.row?.original?.spamId,
        }
      );
      // console.log("res232", res);
      if (res.data.statusDescription.statusCode == 200) {
        SpamTableget();
        toast.success("Updated Successfully!!", {
          theme: "colored",
          toastId: customId1,
        });
      } else {
        setOpen(false);
        toast.error(res.data.statusDescription.statusdescription, {
          theme: "colored",
          toastId: customId1,
        });
      }
    } catch (error) {
      setOpen(false);

      console.log(error);
      await toast.error("Something went wrong", {
        theme: "colored",
      });
    }
  };

  // ...................  . . Save Button Api..................................//
  const SavePost = async (values) => {
    // console.log("x--", mapArray1[attribute2Index]?.attribute);
    setOpen(true);

    try {
      let arrAnd = [];

      for (let i = 0; i < andArray?.length; i++) {
        if (andArray[i]?.attribute?.attribute != "Message Source") {
          if (
            andArray[i]?.attribute != null &&
            andArray[i]?.operations != null &&
            andArray[i]?.values != ""
          ) {
            let obj = {
              // values: "",
              // attribute: null,
              // operations: null,
            };
            console.log(andArray?.[i]?.values);
            let element = andArray?.[i];
            console.log("element--", element);
            obj.values = element?.values;
            obj.operations = element?.operations?.operations;
            // obj.operations =
            //   element?.operations == null ? null : element?.operations?.operations;
            obj.attribute = element?.attribute?.attribute;
            // obj.attribute =
            //   element?.attribute == null ? null : element?.attribute?.attribute;
            arrAnd.push(obj);
          }
        } else {
          // alert("else");
          if (
            andArray[i]?.attribute != null &&
            andArray[i]?.operations != null &&
            // andArray[i]?.values != ""
            andArray[i]?.messageSource != null
          ) {
            let obj = {
              // values: "",
              // attribute: null,
              // operations: null,
            };
            console.log(andArray?.[i]?.values);
            let element = andArray?.[i];
            console.log("element--", element);
            // obj.values = element?.values;
            obj.values = element?.messageSource;
            obj.operations = element?.operations?.operations;
            // obj.operations =
            //   element?.operations == null ? null : element?.operations?.operations;
            obj.attribute = element?.attribute?.attribute;
            // obj.attribute =
            //   element?.attribute == null ? null : element?.attribute?.attribute;
            arrAnd.push(obj);
          }
        }
      }
      // console.log("arrand--", arrAnd);
      let arrOr = [];
      for (let i = 0; i < orArray?.length; i++) {
        if (orArray[i]?.attribute?.attribute != "Message Source") {
          if (
            orArray[i]?.attribute != null &&
            orArray[i]?.operations != null &&
            orArray[i]?.values != ""
          ) {
            let obj2 = {
              // values: null,
              // attribute: null,
              // operations: null,
            };
            // console.log(orArray[i]?.values);
            let element = orArray?.[i];
            obj2.values = element?.values;
            obj2.operations = element?.operations?.operations;
            // obj2.operations =
            //   element?.operations == null ? null : element?.operations?.operations;
            obj2.attribute = element?.attribute?.attribute;
            arrOr.push(obj2);
          }
        } else {
          if (
            orArray[i]?.attribute != null &&
            orArray[i]?.operations != null &&
            // mapArray[i]?.values != ""
            orArray[i]?.messageSource != null
          ) {
            let obj2 = {
              // values: "",
              // attribute: null,
              // operations: null,
            };
            console.log(orArray?.[i]?.values);
            let element = orArray?.[i];
            console.log("element--", element);
            // obj.values = element?.values;
            obj2.values = element?.messageSource;
            obj2.operations = element?.operations?.operations;
            // obj.operations =
            //   element?.operations == null ? null : element?.operations?.operations;
            obj2.attribute = element?.attribute?.attribute;
            // obj.attribute =
            //   element?.attribute == null ? null : element?.attribute?.attribute;
            arrOr.push(obj2);
          }
        }
      }

      // console.log("arrAnd--", arrAnd);
      let arrAction = [];
      for (let i = 0; i < actionArray?.length; i++) {
        if (actionArray[i]?.attribute?.attribute != "Message Source") {
          if (
            actionArray[i]?.attribute != null &&
            actionArray[i]?.operations != null &&
            actionArray[i]?.values != ""
          ) {
            let obj1 = {};
            // console.log(actionArray[i].values);
            let element = actionArray?.[i];
            obj1.values = element?.values;
            obj1.operations = element?.operations?.operations;
            obj1.attribute = element?.attribute?.attribute;
            arrAction.push(obj1);
            // console.log(actionArray[i]?.values);
          }
        } else {
          // alert("else");
          if (
            actionArray[i]?.attribute != null &&
            actionArray[i]?.operations != null &&
            actionArray[i]?.values != ""
          ) {
            let obj1 = {
              // values: "",
              // attribute: null,
              // operations: null,
            };
            console.log(actionArray?.[i]?.values);
            let element = actionArray?.[i];
            console.log("element--", element);
            // obj.values = element?.values;
            obj1.values = element?.messageSource;
            obj1.operations = element?.operations?.operations;
            // obj.operations =
            //   element?.operations == null ? null : element?.operations?.operations;
            obj1.attribute = element?.attribute?.attribute;
            // obj.attribute =
            //   element?.attribute == null ? null : element?.attribute?.attribute;
            arrOr.push(obj1);
          }
        }
      }
      console.log("arrOr--", arrAction);
      // setHideSkeleton(true);

      const result = await common_axios.post(
        // "http://192.168.167.66:5002/v1/get-rules"
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/update/spam/rules`,
        {
          spamId: ResponseEdit?.spamId,
          ruleName: ResponseEdit?.ruleName,
          status: ResponseEdit?.status,
          userId: localStorage.getItem("UserId"),
          priority: ResponseEdit?.priority,
          description: ResponseEdit?.description,
          and: arrAnd.length == 0 ? null : arrAnd,
          or: arrOr.length == 0 ? null : arrOr,
          actionRequests: arrAction,
        },
        {
          headers: {
            username: localStorage.getItem("Username"),
          },
        }
      );
      if (result.data.statusDescription.statusCode == 200) {
        setOpen(false);
        setDisableFieldsRule(true);
        SpamTableget();
        // SpamGet();
        // ActionGet();
        // setRank(null);
        // setResponse("1");
        // setAccountCountryId(null);
        // formik.handleReset();
        // setAtribute1Index(undefined);
        // setAtribute2Index(undefined);
        // setAtribute3Index(undefined);
        // setAccountCountryId(null);
        // setAndArray([
        //   {
        //     attribute: null,
        //     operations: null,
        //     values: "",
        //     butt: "",
        //   },
        // ]);
        // setOrArray([
        //   {
        //     attribute: null,
        //     operations: null,
        //     values: "",
        //     butt: "",
        //   },
        // ]);
        // setActionArray([
        //   {
        //     attribute: null,
        //     operations: null,
        //     values: "",
        //     butt: "",
        //   },
        // ]);
        toast.success("Rule Updated Successfully!", {
          toastId: customId1,
          theme: "colored",
        });
      } else {
        setOpen(false);

        toast.error(result.data.statusDescription.statusdescription, {
          toastId: customId1,
          theme: "colored",
        });
      }
      // else if (
      //   mapArray1[attribute2Index]?.attribute != null &&
      //  mapArray1[attribute2Index]?.operations != null &&
      //   mapArray1[attribute2Index]?.values != "" &&
      //   mapArray[attribute2Index]?.attribute == null &&
      //   mapArray[attribute2Index]?.operations == null &&
      //   mapArray[attribute2Index]?.values == ""
      // ) {
      //   const result = await common_axios.post(
      //     // "http://192.168.167.66:5002/v1/get-rules"
      //     `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/spam`,
      //     {
      //       ruleName: "kfdhjkfh",
      //       userId: "130",
      //       priority: "1",
      //       description: "fdkhifrhk",
      //       or: arrOr,
      //       actionRequest: arrAction,
      //     },
      //     {
      //       headers: {
      //         username: localStorage.getItem("Username"),
      //       },
      //     }
      //   );
      //   if (result.data.statusDescription.statusCode == 200) {
      //     toast.success("Success!", {
      //       theme: "colored",
      //     });
      //   } else {
      //     toast.error(result.data.statusDescription.statusdescription);
      //   }
      // }
    } catch (error) {
      setOpen(false);
      // setHideSkeleton(false);
      console.log("errors--", error);
      toast.error("Please Check Your Network");
    }
  };
  // ...............status code.........................//
  // -----------------------cancel function of update status-----------------------
  // const [status, setStatus] = useState();
  const cancel = (cell) => {
    setStatus(cell.row.original.status);
  };

  const [statuss, setStatuss] = useState();
  const [activeDeactive, setActiveDeactive] = useState();
  // console.log("activeDeactive", activeDeactive);
  // console.log("sattus", statuss);
  const status = (cell) => {
    // console.log("status2", cell);
    setStatuss(cell.row.original.status);
  };

  const columns = useMemo(
    () => [
      {
        Header: "Rule Id",
        Footer: "Rule Id",
        accessor: "spamId", // accessor is the "key" in the data
      },
      {
        Header: "Rule Name",
        Footer: "Rule Name",
        accessor: "ruleName",
      },
      {
        Header: "Created By",
        Footer: "Created By",
        accessor: "createdBy",
      },
      {
        Header: "And Values",
        Footer: "And Values",
        accessor: "andValues",
        Cell: (cell) => {
          return (
            <>
              {/* attribute<h1>dfjgfjdgujdfjh</h1> */}
              {/* {cell?.row?.original?.orValues} */}
              <div
                dangerouslySetInnerHTML={{
                  __html: cell.row.original.andValues,
                }}
              />
            </>
          );
        },
      },
      {
        Header: "Or Values",
        Footer: "Or Values",
        accessor: "orValues",
        Cell: (cell) => {
          return (
            <>
              {/* attribute<h1>dfjgfjdgujdfjh</h1> */}
              {/* {cell?.row?.original?.orValues} */}
              <div
                dangerouslySetInnerHTML={{ __html: cell.row.original.orValues }}
              />
            </>
          );
        },
      },
      {
        Header: "Action Values",
        Footer: "Action Values",
        accessor: "actionValues",
        Cell: (cell) => {
          return (
            <>
              {/* attribute<h1>dfjgfjdgujdfjh</h1> */}
              {/* {cell?.row?.original?.orValues} */}
              <div
                dangerouslySetInnerHTML={{
                  __html: cell.row.original.actionValues,
                }}
              />
            </>
          );
        },
      },
      // {
      //   Header: "Attribute",
      //   Footer: "Attribute",
      //   accessor: "attribute",
      // },

      {
        Header: "Created Date",
        Footer: "Created Date",
        accessor: "createdDate",
      },
      // {
      //   Header: "Values",
      //   Footer: "Values",
      //   accessor: "values",
      // },
      // {
      //   Header: "Response",
      //   Footer: "Response",
      //   accessor: "spamResponse", // accessor is the "key" in the data
      // },
      {
        Header: "Activate/Deactivate",
        Footer: "Activate/Deactivate",
        accessor: "status",
        Cell: (cell) => (
          <div className="">
            <button
              className="btn color_1  "
              type="button"
              id="dropdownMenuButton1"
              aria-expanded="false"
            >
              {console.log("cell111", cell)}
              {cell.row.original.status == 0 ? (
                <>
                  <span class="badge bg-danger activated_1">Deactivated</span>
                </>
              ) : (
                <>
                  <span class="badge bg-success activated_1">Activated</span>
                </>
              )}

              {/* <DeleteIcon /> */}
            </button>
          </div>
        ),

        disableFilters: true,
      },

      {
        Header: "Action",
        Footer: "Action",
        accessor: "action",
        Cell: (cell) => (
          <div className="dropdown">
            <button
              className="btn color_1 "
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {/* <i className="material-icons opacity-10 size">person</i> */}
              <PersonRoundedIcon className="user_i8" />
              <ArrowDropDownIcon className="mn_icon_8" />
              {/* <DeleteIcon /> */}
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li
                onClick={() => {
                  console.log(cell);
                }}
              >
                <a
                  className="dropdown-item"
                  onClick={() => {
                    rejectUserModal(cell);
                  }}
                >
                  {/* reject User */}
                  <DeleteIcon />
                  Delete
                </a>
              </li>
              <li>
                <a
                  className="dropdown-item"
                  onClick={() => {
                    approveUserModal(cell);
                  }}
                >
                  {/* Approve User */}
                  <EditIcon />
                  Edit Details
                </a>
              </li>
              <li>
                <a
                  className="dropdown-item"
                  onClick={() => {
                    ActivateDeactivate(cell);
                  }}
                >
                  {/* {console.log("cell-----", cell)} */}
                  {cell.row.original.status == 0 ? (
                    <>
                      {/* {alert("if")} */}
                      <CheckIcon />
                      Activate
                    </>
                  ) : (
                    <>
                      {/* {alert("else")} */}
                      <RemoveCircleOutlineIcon />
                      Deactivate
                    </>
                  )}

                  {/* <EditIcon />
                  ACtivate */}
                </a>
              </li>
            </ul>
          </div>
        ),

        disableFilters: true,
      },
    ],
    []
  );
  // console.log(Status, "lalalaallalas");

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);

  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    console.log({ selectedFlatRows });
  };

  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };

  // ----------------------------------------------Filter table--------------------------------------------

  return (
    <>
      <main className="main-content position-relative border-radius-lg ">
        <div>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
          >
            <Loader />
          </Backdrop>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-12 col-sm-12 mb-xl-0 mb-4">
              <div class="card mb-3 mt-4">
                <div class="card-header p-3 pt-2">
                  <div class="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
                    <i
                      class="material-icons ttl_icon  opacity-10 rule"
                      style={{ fontSize: "unset" }}
                    >
                      <RuleIcon style={{ fontSize: "28px" }} />
                    </i>
                  </div>
                  <div class="pt-1 marginleft_0">
                    <p class="text-sm mb-0 text-capitalize fw-bold">
                      VIEW RULE
                    </p>
                  </div>
                </div>

                {data?.length > 0 ? (
                  <>
                    {" "}
                    <div class="card-body mt-4">
                      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
                        {/* {selectedUserDetail != undefined && ( */}
                        <div>
                          <button
                            ref={modelButtonReject}
                            type="button"
                            className="btn btn-primary d-none"
                            data-bs-toggle="modal"
                            data-bs-target="#staticBackdrop"
                          >
                            Launch static backdrop modal
                          </button>

                          <div
                            className="modal fade"
                            id="staticBackdrop"
                            data-bs-backdrop="static"
                            data-bs-keyboard="false"
                            tabindex="-1"
                            aria-labelledby="staticBackdropLabel"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5
                                    className="modal-title"
                                    id="staticBackdropLabel"
                                  >
                                    Delete Rule?
                                  </h5>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                  ></button>
                                </div>
                                <div className="modal-body">
                                  <h4>Are you sure to delete this rule?</h4>
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="btn btn-primary delete_1"
                                    data-bs-dismiss="modal"
                                    onClick={() => {
                                      rejectUserApi(selectedUserDetail);
                                    }}
                                  >
                                    Yes
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-secondary w_btn"
                                    data-bs-dismiss="modal"
                                  >
                                    No
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* )} */}
                        {/* {selectedUserDetailApprove != undefined && ( */}

                        <div>
                          <button
                            ref={modelButtonApprove}
                            type="button"
                            className="btn btn-primary d-none"
                            data-bs-toggle="modal"
                            data-bs-target="#staticBackdrop1"
                          >
                            Launch static backdrop modal
                          </button>

                          <div
                            className="modal fade"
                            id="staticBackdrop1"
                            data-bs-backdrop="static"
                            data-bs-keyboard="false"
                            tabindex="-1"
                            aria-labelledby="staticBackdrop1Label"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog modal-xl">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5
                                    className="modal-title"
                                    id="staticBackdrop1Label"
                                  >
                                    Update Details
                                  </h5>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => {
                                      setResponseEdit(undefined);
                                      dispatch(andState(""));
                                    }}
                                  ></button>
                                </div>

                                <div
                                  className="modal-body"
                                  style={
                                    {
                                      // height: "456px",
                                      // width: "455px",
                                      // overflow: "auto",
                                    }
                                  }
                                >
                                  <ul
                                    className="nav nav-tabs"
                                    id="myTab"
                                    role="tablist"
                                  >
                                    <li
                                      className="nav-item list_1"
                                      role="presentation"
                                    >
                                      <button
                                        //  className="nav-link active"

                                        className={
                                          AndOrActionTab == ""
                                            ? "nav-link ms-4 active  position-relative"
                                            : AndOrActionTab == undefined
                                            ? "nav-link ms-4 active  position-relative"
                                            : "nav-link ms-4   position-relative"
                                        }
                                        id="home-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#AccountDetails"
                                        type="button"
                                        role="tab"
                                        aria-controls="AccountDetails"
                                        // aria-selected="true"
                                        aria-selected={
                                          AndOrActionTab == ""
                                            ? "true"
                                            : AndOrActionTab == undefined
                                            ? "true"
                                            : "false"
                                        }
                                        // onClick={schedule}
                                        onClick={() => {
                                          // schedule();
                                          // SchedulePost();

                                          dispatch(AndOrActionState(""));
                                        }}
                                      >
                                        And Condition
                                      </button>
                                    </li>
                                    <li
                                      className="nav-item list_1"
                                      role="presentation"
                                    >
                                      <button
                                        // className="nav-link ms-4 position-relative"
                                        className={
                                          AndOrActionTab == 2
                                            ? "nav-link ms-4 active position-relative"
                                            : "nav-link ms-4  position-relative"
                                        }
                                        id="SenderMasking-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#SenderMasking"
                                        type="button"
                                        role="tab"
                                        aria-controls="SenderMasking"
                                        // aria-selected="false"
                                        aria-selected={
                                          AndOrActionTab == 2 ? "true" : "false"
                                        }
                                        onClick={() => {
                                          dispatch(AndOrActionState("2"));
                                        }}
                                      >
                                        Or Condition
                                      </button>
                                    </li>
                                    <li
                                      className="nav-item list_1"
                                      role="presentation"
                                    >
                                      <button
                                        // className="nav-link ms-2"
                                        className={
                                          AndOrActionTab == 3
                                            ? "nav-link ms-4 active position-relative"
                                            : "nav-link ms-4 position-relative "
                                        }
                                        id="ContactDetails-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#ContactDetails"
                                        type="button"
                                        role="tab"
                                        aria-controls="ContactDetails"
                                        // aria-selected="false"
                                        // onClick={fetchContactDetails}
                                        aria-selected={
                                          AndOrActionTab == 3 ? "true" : "false"
                                        }
                                        onClick={() => {
                                          dispatch(AndOrActionState("3"));
                                        }}
                                      >
                                        Action Condition
                                      </button>
                                    </li>
                                  </ul>
                                  <div
                                    className="tab-content"
                                    id="myTabContent"
                                  >
                                    <div
                                      // className="tab-pane fade show active"
                                      className={
                                        AndOrActionTab == ""
                                          ? "tab-pane fade show active"
                                          : AndOrActionTab == undefined
                                          ? "tab-pane fade show active"
                                          : "tab-pane fade show"
                                      }
                                      id="AccountDetails"
                                      role="tabpanel"
                                      aria-labelledby="AccountDetails-tab"
                                    >
                                      <div>
                                        <AndEdit
                                          // andEditResponse={andEditResponse?.spamResponse}
                                          parentCallback={callbackAndSelector}
                                          disableFieldsRule={disableFieldsRule}
                                        />
                                      </div>
                                    </div>

                                    <div
                                      // className="tab-pane fade"
                                      className={
                                        AndOrActionTab == 2
                                          ? "tab-pane fade show active"
                                          : "tab-pane fade show"
                                      }
                                      id="SenderMasking"
                                      role="tabpanel"
                                      aria-labelledby="SenderMasking-tab"
                                    >
                                      <OrEdit
                                        parentCallback={callbackOrSelector}
                                        disableFieldsRule={disableFieldsRule}
                                      />
                                    </div>
                                    <div
                                      // className="tab-pane fade "
                                      className={
                                        AndOrActionTab == 3
                                          ? "tab-pane fade show active"
                                          : "tab-pane fade show"
                                      }
                                      id="ContactDetails"
                                      role="tabpanel"
                                      aria-labelledby="AccountDetails-tab"
                                    >
                                      <ActionEdit
                                        parentCallback={callbackActionSelector}
                                        disableFieldsRule={disableFieldsRule}
                                      />
                                    </div>

                                    <div
                                      className="tab-pane fade"
                                      id="ContactDetails"
                                      role="tabpanel"
                                      aria-labelledby="AccountDetails-tab"
                                    ></div>
                                  </div>
                                </div>

                                <div className="modal-footer justify-content-center">
                                  <div className="row">
                                    <div className="col-md-12 text-center">
                                      <button
                                        class="btn btn-secondary shadow"
                                        data-bs-dismiss="modal"
                                        onClick={() => {
                                          // DeactivateUserApi(
                                          //   selectedUserDetailApprove
                                          // );
                                          SavePost();
                                        }}
                                        // onClick={SavePost}
                                        // disabled={
                                        //   ((submitDisable || submitDisable1) ==
                                        //     true &&
                                        //     andArray?.length != 0 &&
                                        //     orArray?.length != 0) ||
                                        //   (andArray?.length == 0 &&
                                        //     orArray?.length == 0)
                                        //     ? true
                                        //     : false
                                        // }

                                        // disabled={
                                        //   ((submitDisable || submitDisable1) ==
                                        //     true &&
                                        //     andArray?.length != 0 &&
                                        //     orArray?.length != 0) ||
                                        //   (andArray?.length == 0 &&
                                        //     orArray?.length == 0)
                                        //     ? true
                                        //     : false
                                        // }
                                        disabled={
                                          (submitDisable || submitDisable1) ==
                                            true ||
                                          // (andArray?.length != 0 &&
                                          //   orArray?.length != 0) ||

                                          (andArray?.length == 0 &&
                                            orArray?.length == 0)
                                            ? true
                                            : false
                                        }

                                        //      disabled={
                                        //   (attribute1Index == undefined &&
                                        //     attribute2Index == undefined &&
                                        //     attribute3Index != undefined) ||
                                        //   (attribute1Index != undefined &&
                                        //     (andArray[attribute1Index]?.attribute ==
                                        //       null ||
                                        //       andArray[attribute1Index]
                                        //         ?.operations == null ||
                                        //       (andArray[attribute1Index]?.values ==
                                        //         "" &&
                                        //         andArray[attribute1Index]
                                        //           ?.messageSource == null))) ||
                                        //   (attribute2Index != undefined &&
                                        //     (orArray[attribute2Index]
                                        //       ?.attribute == null ||
                                        //       orArray[attribute2Index]
                                        //         ?.operations == null ||
                                        //       (orArray[attribute2Index]?.values ==
                                        //         "" &&
                                        //         orArray[attribute2Index]
                                        //           ?.messageSource == null))) ||
                                        //   (attribute3Index != undefined &&
                                        //     (actionArray[attribute3Index]
                                        //       ?.attribute == null ||
                                        //       actionArray[attribute3Index]
                                        //         ?.operations == null ||
                                        //       (actionArray[attribute3Index]?.values ==
                                        //         "" &&
                                        //         actionArray[attribute3Index]
                                        //           ?.messageSource == null))) ||
                                        //   (attribute1Index == undefined &&
                                        //     attribute2Index == undefined &&
                                        //     attribute3Index == undefined) ||
                                        //   (attribute2Index === undefined &&
                                        //     attribute1Index == undefined &&
                                        //     attribute3Index == undefined)
                                        // }
                                      >
                                        Submit
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* )} */}

                        <div className="container-fluid p-0">
                          <div className="card shadow-none border bg_blue mb-5">
                            <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                              RULES
                            </span>
                            <div class="card-body mt-2 ">
                              <div>
                                <div></div>
                              </div>

                              <div className="d-flex justify-content-between my-3">
                                <select
                                  value={TableStatus.pageSize}
                                  className="dropdown"
                                  onChange={(e) => {
                                    setPageSize(Number(e.target.value));
                                    setTableStatus({
                                      ...TableStatus,
                                      pageSize: e.target.value,
                                    });
                                  }}
                                >
                                  {[10, 25, 50].map((value, i) => {
                                    return (
                                      <option
                                        className="dropdown-menu"
                                        aria-labelledby="dropdownMenuButton1"
                                        value={value}
                                        key={value}
                                      >
                                        Show {value}
                                      </option>
                                    );
                                  })}
                                </select>
                                {/* 
                                <div className="d-flex align-items-center ">
                                  <span className="d-block">Search</span>

                                  <TextField
                                    className="ms-4 w-100"
                                    style={{
                                      borderRadius: "4px",
                                    }}
                                    type="text"
                                    label="Search"
                                    name="Search"
                                    variant="outlined"
                                    // value={number}
                                    size="small"
                                    value={globalSearchValue || ""}
                                    onChange={(e) => {
                                      onChange(e.target.value);
                                      setGlobalSearchValue(e.target.value);
                                    }}
                                  /> */}
                                {/* </div> */}
                              </div>

                              <div>
                                {selectedFlatRows.length > 0 && (
                                  <button onClick={deletUser}>
                                    Delete Users
                                  </button>
                                )}
                              </div>
                              <div class="table-responsive">
                                <table
                                  {...getTableProps()}
                                  id="example"
                                  className="table table-striped table-bordered dataTable table-sm"
                                  style={{ width: "100%" }}
                                >
                                  <thead>
                                    {headerGroups.map((headerGroup) => (
                                      <tr
                                        {...headerGroup.getHeaderGroupProps()}
                                      >
                                        {headerGroup.headers.map((column) => (
                                          <th
                                            {...column.getHeaderProps(
                                              column.getSortByToggleProps()
                                            )}
                                            className="text-center width_2"
                                          >
                                            {column.render("Header")}
                                            <span>
                                              {column.isSorted
                                                ? column.isSortedDesc
                                                  ? "↑"
                                                  : "↓"
                                                : ""}
                                            </span>
                                          </th>
                                        ))}
                                      </tr>
                                    ))}
                                  </thead>
                                  <tbody id="tbody_9" {...getTableBodyProps()}>
                                    {page.map((row) => {
                                      prepareRow(row);
                                      return (
                                        <tr {...row.getRowProps()}>
                                          {row.cells.map((cell) => {
                                            return (
                                              <td
                                                {...cell.getCellProps()}
                                                className="text-left"
                                              >
                                                {cell.render("Cell")}
                                              </td>
                                            );
                                          })}
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                              <div className="d-flex justify-content-between mt-3">
                                <div>
                                  <span>
                                    Page:
                                    <strong>
                                      {data2?.currentPage + 1} of{" "}
                                      {data2?.totalPage}
                                    </strong>
                                  </span>
                                  {/* <span>
                                          | Go to Page :{""}
                                          <input
                                            type="number"
                                            min="0"
                                            max={totalPage}
                                            // defaultValue={pageIndex}
                                            // defaultValue={totalPageCount}
                                            value={totalPageCount}
                                            // defaultValue={pageNumber1}
                                            onChange={(e) => {
                                              const pageNumber = e.target.value
                                                ? Number(e.target.value)
                                                : 0;
                                              gotoPage(pageNumber);
                                              setPageNumber1(pageNumber);
                                            }}
                                            style={{ width: "50px" }}
                                          />
                                        </span> */}
                                </div>
                                <div className="btn_n800">
                                  <button
                                    className="btn btn_primary "
                                    type="button"
                                    style={{ background: "#2C97D4" }}
                                    disabled={data2?.currentPage == 0}
                                    onClick={() => {
                                      setTableStatus({
                                        ...TableStatus,
                                        pageNo: TableStatus.pageNo - 1,
                                      });
                                    }}
                                  >
                                    Prev
                                  </button>
                                  <button
                                    className="btn btn_primary ms-2"
                                    type="button"
                                    style={{ background: "#2C97D4" }}
                                    disabled={
                                      data2?.totalPage == data2?.currentPage + 1
                                    }
                                    onClick={() => {
                                      setTableStatus({
                                        ...TableStatus,
                                        pageNo: TableStatus.pageNo + 1,
                                      });
                                    }}
                                  >
                                    Next
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </main>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="text-center">
                      {data?.length == 0 && open ? null : (
                        <div className="text-center">
                          <h5>Data Not Found</h5>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default RuleList;
